import React from "react";
import { Switch, Route, Redirect } from "react-router-dom";

import { clientUrls } from "misc/urls";
import { CheckAppPermissions } from "misc/authentication";

import CmContainer from "./cm/containers/CmContainer";
import VlvContainer from "./vlv/containers/VlvContainer";
import CddaContainer from "./cdda/containers/CddaContainer";
import BmContainer from "./bm/containers/BmContainer";
import EngineeringContainer from "./engineering/containers/EngineeringContainer";
import DiagnosticsContainer from "./diagnostics/containers/DiagnosticsContainer";
import EnergyMonitorContainer from "./energy_monitor/containers/EnergyMonitorContainer";

const ModulesContainer = () => {
    return (
        <Switch>
            <Route path={clientUrls.modules.vlv.baseUrl()} component={VlvContainer} />
            <Route path={clientUrls.modules.cdda.baseUrl()} component={CddaContainer} />
            <Route path={clientUrls.modules.diagnostics.baseUrl()} component={DiagnosticsContainer} />
            <Route path={clientUrls.modules.cm.baseUrl()} component={CmContainer} />
            <Route path={clientUrls.modules.energyMonitor.baseUrl()} component={EnergyMonitorContainer} />
            <Route path={clientUrls.modules.engineering.baseUrl()} component={EngineeringContainer} />
            <Route path={clientUrls.modules.bm.baseUrl()}>
                <CheckAppPermissions allowed={["permission_module_bm"]} fallback={<Redirect to={clientUrls.modules.vlv.baseUrl()} />}>
                    <BmContainer />
                </CheckAppPermissions>
            </Route>

            <Redirect to={clientUrls.modules.vlv.baseUrl()} />
        </Switch>
    );
};

export default ModulesContainer;
